<template>
  <div class="content">
    <div v-if="$store.state.utils.configuration.enableNewRecipeDeclinedModal">
      <div class="new-modal-error-icon">!</div>
      <h2 class="new-modal-title">{{ translations.moderationHeader }}</h2>
      <p class="new-modal-description">
        {{ translations.moderationDescription }}
      </p>
    </div>
    <h5 class="text-center subheader" v-else >
      {{ translations.recipeDeclinedSubHeader1 }}<br/>
      {{ translations.recipeDeclinedSubHeader2 }}
    </h5>
  </div>
</template>

<script>
export default {
  name: "recipeDeclinedModal",
  props: {
    productName: {
      type: String,
      default: ''
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
};
</script>
